// extracted by mini-css-extract-plugin
export default {"icon-default":"yn7zj","icon-default__size-m":"MyMgH","icon":"oeX9m"};